export const BRAND_INTEL_TOUR_STEPS = [
  {
    target: 'body',
    title: 'Brand & Market Intel Hub',
    content:
      "Welcome! Let's walk you through the key sections of this dashboard so you can get insights fast.",
    placement: 'center',
    disableBeacon: true,
  },
  {
    target: '[data-tour="bi-company-selector"]',
    title: 'Your Saved Companies',
    content:
      'Select the brand or company you want to analyse. Use the group tabs to organise your brands, or click "Manage/Edit companies" to add new ones.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="bi-control-bar"]',
    title: 'Control Bar',
    content:
      'This is your command centre. Set keywords (Topic), apply advanced filters, choose a date range, set the data interval, and hit Fetch Insights to load your data.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="bi-topic-btn"]',
    title: 'Topic / Keywords',
    content:
      'Click here to enter or edit the keywords and topics associated with this company. These drive what social data gets pulled in.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="bi-filters-btn"]',
    title: 'Filters',
    content:
      'Narrow your results by date range, language, gender, country, and content type. Click to open the filters panel.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="bi-fetch-btn"]',
    title: 'Fetch Insights',
    content:
      'Once you have set your company, topic, and filters — click Fetch Insights to load the latest data from all selected social platforms.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="bi-social-selector"]',
    title: 'Social Media Selector',
    content:
      'Choose which platforms to include — Instagram, TikTok, YouTube, Twitter, Facebook, News & Articles. Mix and match to compare across channels.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="bi-summary-cards"]',
    title: 'Summary KPI Cards',
    content:
      'At a glance stats: total posts, comments, positive, negative and neutral sentiment counts, and follower numbers. Click any card to drill down.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '[data-tour="dashboard-charts"]',
    title: 'Insight Charts',
    content:
      'Select any insight pill above the charts to switch between views — Sentiment Timeline, Mention Trends, Audience Demographics, Top Influencers, and more.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '[data-tour="bi-download-report"]',
    title: 'Download Report',
    content:
      'Export the full dashboard as a PDF report — great for sharing with your team or presenting to clients.',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="bi-fetch-btn"]',
    title: "You're all set!",
    content:
      'You can replay this guide anytime by clicking the Guide button in the top header. Hit Fetch Insights to load your first report!',
    placement: 'bottom',
    disableBeacon: true,
  },
];
